// extracted by mini-css-extract-plugin
export var centerText = "_fy-8";
export var container = "_fy-0";
export var doughnutContainer = "_fy-7";
export var legend = "_fy-a";
export var legendItemColorDisplay = "_fy-b";
export var legendItemLabel = "_fy-d";
export var legendItemValue = "_fy-c";
export var lg = "_fy-5";
export var maxWidth = "_fy-9";
export var md = "_fy-4";
export var responsive = "_fy-6";
export var sm = "_fy-3";
export var xs = "_fy-2";
export var xxs = "_fy-1";